<template>
  <div v-if="loaded">
    <v-data-table
      :headers="headers"
      :items="batches"
      :pagination.sync="pagination"
      :total-items="total"
      :rows-per-page-items="[10, 20, 30, 50]"
      @update:pagination="updatePagination"
    >
      <template
        slot="items"
        slot-scope="{ item }"
      >
        <td>
          <v-icon
            v-if="item.status == Consts.BATCHES_STATUS.WAITING"
            color="info"
            title="Waiting"
          >
            mdi-circle-outline
          </v-icon>
          <v-icon
            v-else-if="item.status == Consts.BATCHES_STATUS.PROCESSING"
            color="warning"
            title="Processing"
          >
            mdi-circle-outline
          </v-icon>
          <v-icon
            v-else
            color="success"
            title="Completed"
          >
            mdi-circle-outline
          </v-icon>
        </td>
        <td>{{ item.created_by }}</td>
        <td>{{ formatDateHuman(item.created_at, true) }}</td>
        <td>{{ formatDateHuman(item.finished_at, true) }}</td>
        <td>
          <v-btn
            :disabled="item.status != Consts.BATCHES_STATUS.FINISHED"
            class="mx-0"
            icon
            title="Download the ZIP file"
            @click="downloadZIP(item)"
          >
            <v-icon>mdi-folder-zip-outline</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import DateMixin from '@/mixins/date'
  import GlobalMixin from '@/mixins/global'
  import Consts from '@/consts'
  import Indemnities from '@/api/indemnities'

  export default {
    mixins: [DateMixin, GlobalMixin],
    props: {
      status: {
        type: Number,
        default: () => Consts.BATCHES_STATUS.WAITING
      }
    },
    data () {
      return {
        batches: [],
        headers: [
          { text: 'Status', value: 'status', width: 30 },
          { text: 'Created by', value: 'created_by'},
          { text: 'Created at', value: 'created_at' },
          { text: 'Completed at', value: 'finished_at' },
          { text: '', value: '', width: 80 },
        ],
        total: 0,
        pagination: {
          sortBy: 'created_at',
          descending: true,
          page: 1,
          rowsPerPage: 10,
          totalItems: 0
        },
        lastPagination: null,
        Consts,
        loaded: false
      }
    },
    mounted() {
      const storedPagination = this.getStoredObject("indemnities_batches.pagination")
      if(storedPagination) {
        this.pagination = storedPagination
      }
      this.fetch()
    },
    methods: {
      async fetch(from = 'local') {
        if(from == 'filters') {
          this.pagination.page = 1
        }
        const params = Object.assign({}, this.pagination, {status: this.status})
        const {data} = await Indemnities.getBatches(params)
        this.batches = data.items
        this.pagination.totalItems = data.total
        this.total = data.total
        if(from == 'filters') {
          this.updatePagination(this.pagination, false)
        }
        this.loaded = true
      },
      updatePagination(pagination, fetch = true) {
        //Très très très galère pour ne pas avoir 50 appels à l'API
        if (this.lastPagination && JSON.stringify(pagination) !== JSON.stringify(this.lastPagination)) {
          this.lastPagination = { ...pagination }
          this.setStoredObject("indemnities_batches.pagination", pagination)
          if(fetch) {
            this.fetch()
          }
        }
        if( ! this.lastPagination) {
          this.lastPagination = { ...pagination }
        }
      },
      async downloadZIP(batch) {
        Indemnities.getBatchZIP(batch.id).then(res => {
          let blob = new Blob([res.data], {type: "octet/stream"});

          if (window.navigator && window.navigator.msSaveOrOpenBlob){
            window.navigator.msSaveBlob(blob, `POP-batch_${batch.created_at}.zip`)
          }
          else
          {
            let a = document.createElement("a")
            a.style = "display: none"
            document.body.appendChild(a)
            let url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = `POP-batch_${batch.created_at}.zip`
            a.click()
            window.URL.revokeObjectURL(url)
          }
        })
      }
    }
  }
</script>

<style scoped lang="sass">
  .txt-right
    text-align: right
</style>
